import { render, staticRenderFns } from "./Bto.vue?vue&type=template&id=fab45dc6&"
import script from "./Bto.vue?vue&type=script&lang=js&"
export * from "./Bto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports